<script lang="ts">import { iconActive, iconHover } from "./colors";
export let size = 23;
export let active = false;
export let color = undefined;
let width = size;
let height = Math.floor(.9 * width);
let fill = color ? color : active ? iconActive : iconHover;
$: fill = color ? color : active ? iconActive : iconHover;
</script>

<svg fill="none" {height} viewBox="0 0 27 27" {width} xmlns="http://www.w3.org/2000/svg">
	<path
		d="M5.35623 18.5884L10.8386 0.880005C10.7859 0.882475 10.7325 0.880067 10.6822 0.898163L1.04767 4.23738C0.220788 4.52581 -0.205985 5.40109 0.0980995 6.18028L6.52112 23.0032C6.6705 23.3877 6.96391 23.6914 7.35333 23.8633C7.56674 23.9545 7.79613 23.9999 8.02552 23.9999C8.21222 23.9999 8.39896 23.9695 8.57498 23.9089L11.7032 22.8242L7.13638 21.5934C5.76883 21.2179 4.97279 19.8705 5.35623 18.5884Z"
		{fill}
	/>
	<path
		d="M26.478 3.91804C26.2859 3.58409 25.9659 3.34625 25.5818 3.24508L14.0859 0.143587L13.7445 0.0524881C12.9657 -0.154908 12.1441 0.270075 11.9094 1.01387L6.38286 18.8639C6.15882 19.6127 6.61758 20.3969 7.42844 20.6196L19.255 23.8071C19.3884 23.8424 19.5218 23.8627 19.6551 23.8627C20.3006 23.8627 20.8981 23.463 21.0901 22.8457L26.606 5.00073C26.718 4.63139 26.6754 4.24686 26.478 3.91804ZM19.5164 13.2579L15.9583 17.2297C15.857 17.341 15.7076 17.4067 15.5529 17.4067C15.5209 17.4067 15.4835 17.4017 15.4515 17.3966C15.2595 17.3611 15.1048 17.2297 15.0461 17.0526L13.3711 12.0942C13.3177 11.9273 13.3551 11.7451 13.4725 11.6136L17.0306 7.64179C17.1586 7.50017 17.356 7.43946 17.5427 7.47491C17.7294 7.5103 17.8841 7.64179 17.9481 7.81386L19.6178 12.7773C19.6765 12.9442 19.6391 13.1264 19.5164 13.2579Z"
		{fill}
	/>
	<defs>
		<linearGradient
			gradientUnits="userSpaceOnUse"
			id="paint0_linear_319_22787"
			x1="5.90337"
			x2="5.90336"
			y1="1.747"
			y2="23.9999"
		>
			<stop stop-color="#3EFFB4" />
			<stop offset="1" stop-color="#01D180" />
		</linearGradient>
		<linearGradient
			gradientUnits="userSpaceOnUse"
			id="paint1_linear_319_22787"
			x1="16.5865"
			x2="16.5865"
			y1="0.894851"
			y2="23.8627"
		>
			<stop stop-color="#3EFFB4" />
			<stop offset="1" stop-color="#01D180" />
		</linearGradient>
	</defs>
</svg>
